<template>
<div>
  <div class="content">
    <van-form @submit="submitJsy">
      <van-cell-group inset>
        <ChoseVehicleUsage  :disabled="purposeDisabled" :vehicleUsage="vehicleUsage.typecode"  @changeVehicleUsage="changeVehicleUsage"/>
        <div class="upload-box">
          <h2 class="upload-titile input-title-hq red-required">行驶证正页 <span class="image-show" @click="showImageDemo('zbfm')">（示例:如图）</span></h2>
          <div class="upload-xsz-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_zb_fm_image" :before-read="beforeRead" :after-read="uploadXszZbFm" :before-delete="deleteXszZbFm"></van-uploader>
          </div>

         <div v-if="vehicleUsage.typecode == '2'">
           <h2 class="upload-titile input-title-hq red-required">行驶证副页<span class="image-show" @click="showImageDemo('fbzm')">（示例:如图）</span></h2>
           <div class="upload-xsz-box">
             <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_fb_zm_image" :before-read="beforeRead" :after-read="uploadXszFbZm" :before-delete="deleteXszFbZm"></van-uploader>
           </div>

           <h2 class="upload-titile input-title-hq red-required">行驶证副页反面<span class="image-show" @click="showImageDemo('fbfm')">（示例:如图）</span></h2>
           <div class="upload-xsz-box">
             <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_fb_fm_image" :before-read="beforeRead" :after-read="uploadXszFbFm" :before-delete="deleteXszFbFm"></van-uploader>
           </div>

           <h2 class="upload-titile input-title-hq red-required">行驶证机动车照片<span class="image-show" @click="showImageDemo('zbzm')">（示例:如图）</span></h2>
           <div class="upload-xsz-box">
             <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_zb_zm_image" :before-read="beforeRead" :after-read="uploadXszZbZm" :before-delete="deleteXszZbZm"></van-uploader>
           </div>
         </div>

          <div class="jsz-front-info-box">
            <van-field v-model="cheguahao" name="cheguahao" required :value="cheguahao" :rules="[{ validator:validatorChegua, message: '请填写车挂号' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">车挂号</span>
              </template>
            </van-field>
            <van-field v-show="cheShow" v-model="chejiahao" name="chejiahao" :value="chejiahao" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">车辆识别代号</span>
              </template>
            </van-field>

            <van-field v-model="sscd" name="sscd" required :value="sscd" :rules="[{ validator:validatorSscd, message: '请填写所属车队' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">所属车队</span>
              </template>
            </van-field>
            <van-field name="radio" label="是否集装箱" required :rules="[{ validator:validatorSfjzx, message: '请确认是否集装箱' }]" input-align="right" label-width="10rem">
              <template #input>
                <van-radio-group v-model="sfjzx" direction="horizontal">
                  <van-radio name="Y">是</van-radio>
                  <van-radio name="N">否</van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <van-field v-if="vehicleUsage.typecode == '2'" v-model="zhengbeizhiliang" name="zhengbeizhiliang" required :value="zhengbeizhiliang" type="number" :rules="[{ validator:validatorZbzl, message: '请填写整备质量' }]">
              <template #extra>
                <div class="unit">KG</div>
              </template>
              <template #label>
                <span class="input-left-label-hq">整备质量</span>
              </template>
            </van-field>

            <van-field v-if="vehicleUsage.typecode == '2'" v-model="xingshizhenghdzzl" name="xingshizhenghdzzl" required type="number" :value="xingshizhenghdzzl" :rules="[{ validator:validatorXingshizhenghdzzl, message: '请填写行驶证核定载质量' }]">
              <template #extra>
                <div class="unit">吨</div>
              </template>
              <template #label>
                <span class="input-left-label-hq">行驶证核定载质量</span>
              </template>
            </van-field>

            <ChoseTime v-if="vehicleUsage.typecode == '2'" :timeVmodel="xszYxq" :timeName="xszYxq" :timeLabel="xszYxqLabel" @getYxq="getXszYxq" :timeValue="xingshizhengyxq" />
            
            <van-field 
              v-model="cssl" 
              name="cssl" 
              readonly
              clickable
              required 
              input-align="right"
              is-link
              :rules="[{ validator:validatorCssl, message: '请选择隔舱数量' }]"
              placeholder="请选择隔舱数量"
              @click="showCsslPicker = true">
              <template #label>
                <span class="input-left-label-hq">隔舱数量</span>
              </template>
            </van-field>
            
            <!-- 货舱数量选择器弹出层 -->
            <van-popup v-model="showCsslPicker" position="bottom" round>
              <van-picker
                show-toolbar
                title="选择隔舱数量"
                :columns="csslColumns"
                @confirm="onCsslConfirm"
                @cancel="showCsslPicker = false"
              />
            </van-popup>
            
          </div>
        </div>
      </van-cell-group>
      <div class="itemBox" v-if="vehicleUsage.typecode == '2'">
        <cabin-item :cabinValue="cabinValue" :cangshilifang1="cangshilifang1" :cangshilifang2="cangshilifang2" :cangshilifang3="cangshilifang3" @setCabin="setCabin" @getCsValue1="getCsValue1" @getCsValue2="getCsValue2" @getCsValue3="getCsValue3"></cabin-item>
         
      </div>
      <div class="itemBox" >
        <van-cell-group inset>
          <div v-show="vehicleUsage.typecode == '2'">
          <div class="upload-box">
            <h2 class="upload-titile  input-title-hq red-required">道路运输证正本正面图片 <span class="image-show" @click="showImageDemo('dlyszm')">（示例:如图）</span></h2>
            <div class="upload-dlysz-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dlys_zm_image" :before-read="beforeRead" :after-read="uploadDlysZm" :before-delete="deleteDlysZm"></van-uploader>
            </div>
            <h2 class="upload-titile  input-title-hq title-extend red-required">道路运输证（待理证）正面图片<span>（车辆信息和经营范围2页拍在一起）</span> <span class="image-show" @click="showImageDemo('dlczm')">（示例:如图）</span></h2>
            <div class="upload-dlysz-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dcl_zm_image" :before-read="beforeRead" :after-read="uploadDclZm" :before-delete="deleteDclZm"></van-uploader>
            </div>
            <h2 class="upload-titile  input-title-hq title-extend red-required">道路运输证（待理证）反面图片 <span class="image-show" @click="showImageDemo('dlcfm')">（示例:如图）</span></h2>
            <div class="upload-dlysz-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dcl_fm_image" :before-read="beforeRead" :after-read="uploadDclFm" :before-delete="deleteDclFm"></van-uploader>
            </div>

            <ChoseTime :timeVmodel="dlysYxq" :timeName="dlysYxq" :timeLabel="dlysYxqLabel" @getYxq="getDlysYxq" :timeValue="daoluyszyxq" :timeRequire="false"/>
            <ChosePz :pzTitle="pzTitle" :isShowImportant="true" @getChosePz="getDlysChosePz" :resultPz="pzArray" />

            <h2 class="upload-titile input-title-hq title-extend">罐检图片（请上传含车挂号、罐容、介质、有效期页面的图片）</h2>
            <div class="upload-dlysz-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" v-model="guanjianbgimage" :before-read="beforeRead" :after-read="uploadGtImage" :before-delete="deleteGtImage"></van-uploader>
            </div>

            <van-field v-model="guantitiji" name="guantitiji" required :value="guantitiji" type="number" :rules="[{ validator:validatorGuantitiji, message: '请填写罐体体积' }]">
              <template #extra>
                <div class="unit">立方</div>
              </template>
              <template #label>
                <span class="input-left-label-hq">罐体体积</span>
              </template>
            </van-field>
          </div>
          </div>

            <ChoseGtMaterial :gtMaterial="guanticaizhi"  @changeGtMaterial="changeGtMaterial"/>
            <div v-show="vehicleUsage.typecode == '2'">
            <ChoseTime :timeVmodel="guanjianyxq" :timeName="guanjianyxq" :timeLabel="guanjianyxqLabel" @getYxq="getguanjianyxq" :timeValue="guanjianyxq" :timeRequire="false" />

            <ChosePz :pzTitle="gtPzTitle" :isShowImportant="false" @getChosePz="getGtChosePz" :resultPz="gtPzArray" />
            </div>
            <van-field v-model="beizhu" autosize name="beizhu" label="备注" type="textarea" rows="3" maxlength="50" placeholder="请输入备注" :value="beizhu">
              <template #label>
                <span class="input-left-label-hq">备注</span>
              </template>
            </van-field>
        </van-cell-group>
      </div>
      <div style="margin: 1rem;">
        <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn" color="#316892">
          保存
        </van-button>
      </div>
    </van-form>
    <Tabbar></Tabbar>
  </div>
</div>
</template>

<script>
import api from "@/fetch/api"
import autoSubmitBeian from "@/mixins/autoSubmitBeian";
import {
  Toast,
  Dialog,
  ImagePreview
} from 'vant';
import ChoseTime from "../Public/choseTime.vue";
import ChosePz from "../Public/chosePz.vue";
import Compressor from 'compressorjs';
import Tabbar from '../Public/tabbarTpl.vue';
import CabinItem from '../Vehicle/cabinItem.vue';
import ChoseGtMaterial from '../Vehicle/choseGtMaterial.vue';
import ChoseVehicleUsage from '../Public/choseVehicleUsage.vue';
export default {
  mixins: [autoSubmitBeian],
  components: {
    ChoseTime,
    ChosePz,
    Tabbar,
    CabinItem,ChoseGtMaterial,ChoseVehicleUsage
  },

  data() {
    return {
      cheShow: false,
      xsz_zb_zm_image: [],
      xsz_zb_fm_image: [],
      xsz_fb_zm_image: [],
      xsz_fb_fm_image: [],
      xsz_zb_zm_url: "",
      xsz_zb_fm_url: "",
      xsz_fb_zm_url: "",
      xsz_fb_fm_url: "",

      //行驶证正本反面
      cheguahao: "", //车头号
      sscd: "", //所属车队
      sfjzx:"",//是否集装箱
      chejiahao: "", //车辆识别代号 行驶证正本反面

      //行驶证副本正面
      xingshizhengyxq: "", //行驶证有效期
      zhengbeizhiliang: 0, //整备质量
      xingshizhenghdzzl: 0, //行驶证核定载质量

      xszYxq: "xingshizhengyxq",
      xszYxqLabel: "行驶证有效期",
      dlysYxq: "daoluyszyxq",
      dlysYxqLabel: "道路运输证有效期",

      pzTitle: "道路运输证经营范围",

      gtPzTitle: "罐检经营范围",

      dlys_zm_image: [],
      dcl_zm_image: [],
      dcl_fm_image: [],
      dlys_zm_url: "",
      dcl_zm_url: "",
      dcl_fm_url: "",

      daoluyszhao: "", //道路运输证号
      daoluyszjyfw: "", //道路运输证经营范围
      daoluyszyxq: "", //道路运输证有效期
      beizhu: "",

      loadingBtn: false,
      pzList: [], //品种信息
      selectedData: [],
      gtSelectedData: [],
      guantitiji: 0,
      guanjianyxq: "",
      guanjianyxq_title: "guanjianyxq",
      guanjianyxqLabel: "罐检有效期",
      guanjianjyfw: "",
      guanjianbgurl: "",
      guanjianbgurlArr: [],
      guanjianbgImageArr: [],
      guanjianbgimage: [],
      pzArray: [],
      gtPzArray: [],
      id: 0,
      gzInfo: false,
      cabinValue:"",
      cangshilifang1:0,
      cangshilifang2:0,
      cangshilifang3:0,
      guanticaizhi:"",

      vehicleUsage:[],
      showUsagePicker:false,
      UsageColumns: [],
      timeRequire:true,
      cssl: "", // 货舱数量
      showCsslPicker: false, // 控制货舱数量选择器的显示
      csslColumns: Array.from({length: 12}, (_, i) => (i + 1).toString()), // 1-12的选项,
      purposeDisabled:false
    };
  },
  created() {
    document.title = "编辑车挂信息";
    var id = this.$route.params.id;
    this.$data.id = id;
    this.$nextTick(()=>{
      this.getCheguaBeianDetail(id);
    })
  },
  methods: {
    changeVehicleUsage(data)
    {
       if(data)
      {
        this.vehicleUsage = data;
        if(this.vehicleUsage.typecode == '1'){
          this.timeRequire = false;
        }
        else{
          this.timeRequire = true;
        }
      }
    },
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },
    onOversize() {
      Toast('文件大小不能超过 10Mb');
    },
    validatorChegua(val) {
      if (!val) {
        Toast.fail('请填写车挂号');
        return false;
      }
      return val;
    },
    validatorSfjzx(val) {
      if (!val) {
        Toast.fail('请选择是否为集装箱');
        return false;
      }
      return val;
    },
    validatorChejia(val) {
      if (!val) {
        Toast.fail('请填写车辆识别代号');
        return false;
      }
      return val;
    },
    validatorDaoluyszhao(val) {
      if (!val && this.vehicleUsage.typecode == '2') {
        Toast.fail('请填写道路运输证号');
        return false;
      }
      return val;
    },
    validatorSscd(val) {
      if (!val) {
        Toast.fail('请填写所属车队');
        return false;
      }
      return val;
    },
    validatorZbzl(val) {
      if (!val  && this.vehicleUsage.typecode == '2') {
        Toast.fail('请填写整备质量');
        return false;
      }
      return val;
    },

    validatorXingshizhenghdzzl(val) {
      if (!val) {
        Toast.fail('请填写行驶证核定载质量');
        return false;
      }
      return val;
    },
    validatorGuantitiji(val) {
      if (!val) {
        Toast.fail('请填写罐体体积');
        return false;
      }
      return val;
    },
    validatorCssl(val) {
      if (!val) {
        Toast.fail('请选择货舱数量');
        return false;
      }
      return val;
    },
    onCsslConfirm(value) {
      this.cssl = value;
      this.showCsslPicker = false;
    },
    getCheguaBeianDetail(id) {
      var that = this;
      var weburl = that.GLOBAL.weburl;
      api.getCheguaBeianDetail(id).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == "0") {
          var detail = res.data;
          that.vehicleUsage.typecode = detail.vehicleUsage;
          if(that.vehicleUsage.typecode == '2'){
            that.purposeDisabled = true
          }
          that.cheguahao = detail.cheguahao;
          that.xingshizhengyxq = detail.xingshizhengyxq;
          that.sscd = detail.sscd;
          that.zhengbeizhiliang = detail.zhengbeizhiliang ? detail.zhengbeizhiliang : 0;
          that.chejiahao = detail.chejiahao;
          that.xingshizhenghdzzl = detail.xingshizhenghdzzl;
          that.daoluyszhao = detail.daoluyszhao;
          that.beizhu = detail.beizhu;
          that.daoluyszyxq = detail.daoluyszyxq;
          that.guantitiji = detail.guantitiji ? detail.guantitiji : 0;
          that.guanjianyxq = detail.guanjianyxq;
          that.guanjianjyfw = detail.guanjianjyfw;
          that.guanticaizhi = detail.guanticaizhi;
          that.sfjzx = detail.sfjzx;
          that.cssl = detail.cssl || "";

          var daoluyszjyfw = that.daoluyszjyfw = detail.daoluyszjyfw;
          var pzArrayOld = daoluyszjyfw ? daoluyszjyfw.split('|') : [];

          let pzArrayNew = [];
          for (var i = 0; i < pzArrayOld.length; i++) {
            pzArrayNew.push(pzArrayOld[i]);
          }
          that.selectedData = that.pzArray = pzArrayNew;

          var guanjianjyfw = that.guanjianjyfw;
          var gtPzArrayOld = guanjianjyfw ? guanjianjyfw.split('|') : [];

          let gtPzArrayNew = [];
          for (var j = 0; j < gtPzArrayOld.length; j++) {
            gtPzArrayNew.push(gtPzArrayOld[j]);
          }
          that.gtPzArray = that.gtSelectedData = gtPzArrayNew;

          that.$data.xsz_zb_zm_url = detail.xingshizhengzbzmurl ? detail.xingshizhengzbzmurl : "";
          that.$data.xsz_zb_fm_url = detail.xingshizhengzbfmurl ? detail.xingshizhengzbfmurl : "";
          that.$data.xsz_fb_zm_url = detail.xingshizhengfbzmurl ? detail.xingshizhengfbzmurl : "";
          that.$data.xsz_fb_fm_url = detail.xingshizhengfbfmurl ? detail.xingshizhengfbfmurl : "";
          that.$data.dlys_zm_url = detail.daoluyszzbzmurl ? detail.daoluyszzbzmurl : "";
          that.$data.dcl_zm_url = detail.daoluyszdlzmurl ? detail.daoluyszdlzmurl : "";
          that.$data.dcl_fm_url = detail.daoluyszdlfmurl ? detail.daoluyszdlfmurl : "";

          that.$data.xsz_zb_zm_image = detail.xingshizhengzbzmurl ? [{
            url: weburl + '/' + detail.xingshizhengzbzmurl
          }] : [];
          that.$data.xsz_zb_fm_image = detail.xingshizhengzbfmurl ? [{
            url: weburl + '/' + detail.xingshizhengzbfmurl
          }] : [];
          that.$data.xsz_fb_zm_image = detail.xingshizhengfbzmurl ? [{
            url: weburl + '/' + detail.xingshizhengfbzmurl
          }] : [];
          that.$data.xsz_fb_fm_image = detail.xingshizhengfbfmurl ? [{
            url: weburl + '/' + detail.xingshizhengfbfmurl
          }] : [];
          that.$data.dlys_zm_image = detail.daoluyszzbzmurl ? [{
            url: weburl + '/' + detail.daoluyszzbzmurl
          }] : [];
          that.$data.dcl_zm_image = detail.daoluyszdlzmurl ? [{
            url: weburl + '/' + detail.daoluyszdlzmurl
          }] : [];
          that.$data.dcl_fm_image = detail.daoluyszdlfmurl ? [{
            url: weburl + '/' + detail.daoluyszdlfmurl
          }] : [];

          var guanjianbgurl = detail.guanjianbgurl;
          var guanjianbgImageArr = that.guanjianbgImageArr;
          var guanjianbgurlArr = that.guanjianbgurlArr;
          if (guanjianbgurl) {
            var imageDataArr = guanjianbgurl.split(',');
            for (var k = 0; k < imageDataArr.length; k++) {
              if (guanjianbgImageArr.length > 0) {
                guanjianbgImageArr.push({
                  'url': weburl + '/' + imageDataArr[k]
                });
                guanjianbgurlArr.push(imageDataArr[k]);
              } else {
                guanjianbgImageArr = imageDataArr[k] ? [{
                  url: weburl + '/' + imageDataArr[k]
                }] : [];
                guanjianbgurlArr = imageDataArr[k] ? [imageDataArr[k]] : [];
              }
            }

            that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgImageArr;
            that.guanjianbgurlArr = guanjianbgurlArr;
          }

          switch (detail.cangshi) {
            case "01":
              that.cabinValue = "单舱";
              break;
            case "02":
              that.cabinValue = "双舱";
              break;
            case "03":
              that.cabinValue = "三舱";
              break;
          }

          that.cangshilifang1 = detail.cangshilifang1;
          that.cangshilifang2 = detail.cangshilifang2;
          that.cangshilifang3 = detail.cangshilifang3;


          if(that.vehicleUsage.typecode == '1'){
            that.timeRequire = false;
          }
          else{
            that.timeRequire = true;
          }

        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    submitJsyTwo(values) {
      var cheguahao = values.cheguahao;
      if (cheguahao.length < 5) {
        Toast.fail("请输入正确的车挂号");
        return false;
      }

      Dialog.confirm({
          message: "请确认录入的车挂号" + cheguahao + "是否正确?",
        })
        .then(() => {
          this.submitJsy(values);
          // on confirm
        })
        .catch(() => {
          // on cancel
          return false;
        });
    },
    //提交表单
    submitJsy(values) {
      var that = this;

      var xingshizhengzbfmurl = that.xsz_zb_fm_url ? that.xsz_zb_fm_url : "";
      var xingshizhengfbzmurl = that.xsz_fb_zm_url ? that.xsz_fb_zm_url : "";
      var xingshizhengfbfmurl = that.xsz_fb_fm_url ? that.xsz_fb_fm_url : "";
      var xingshizhengzbzmurl = that.xsz_zb_zm_url ? that.xsz_zb_zm_url : "";

      var daoluyszzbzmurl = that.dlys_zm_url ? that.dlys_zm_url : "";
      var daoluzmurl = that.dcl_zm_url ? that.dcl_zm_url : "";
      var daolufmurl = that.dcl_fm_url ? that.dcl_fm_url : "";
      
      if (!xingshizhengzbfmurl) {
        Toast.fail('请上传行驶证正页');
        return false;
      }
      if (!xingshizhengfbzmurl && that.vehicleUsage.typecode == '2') {
        Toast.fail('请上传行驶证副页');
        return false;
      }
      if(!xingshizhengfbfmurl && that.vehicleUsage.typecode == '2')
      {
        Toast.fail('请上传行驶证副页反面');
        return false;
      }
      if(!xingshizhengzbzmurl && that.vehicleUsage.typecode == '2')
      {
        Toast.fail('请上传行驶证机动车照片');
        return false;
      }

      if(that.vehicleUsage.typecode == '2'){
        if (!daoluyszzbzmurl) {
          Toast.fail('请上传道路运输证正本正面图片');
          return false;
        }
        if(!daoluzmurl)
        {
          Toast.fail('请上传道路运输证（待理证）正面图片');
          return false;
        }
        if(!daolufmurl)
        {
          Toast.fail('请上传道路运输证（待理证）反面图片');
          return false;
        }

        var selectedData = that.$data.selectedData;
        if (selectedData.length == 0) {
          Toast.fail('请选择道路运输证经营范围');
          return false;
        }

        var gtSelectedData = that.$data.gtSelectedData;

        var guanjianjyfw = "";
        if (gtSelectedData.length > 0) {
          for (var j = 0; j < gtSelectedData.length; j++) {
            guanjianjyfw += gtSelectedData[j] + "|";
          }
          //去掉最后一个逗号(如果不需要去掉，就不用写)
          if (guanjianjyfw.length > 0) {
            guanjianjyfw = guanjianjyfw.substr(0, guanjianjyfw.length - 1);
          }
        }

        var daoluyszjyfw = "";
        for (var i = 0; i < selectedData.length; i++) {
          daoluyszjyfw += selectedData[i] + "|";
        }
        //去掉最后一个逗号(如果不需要去掉，就不用写)
        if (daoluyszjyfw.length > 0) {
          daoluyszjyfw = daoluyszjyfw.substr(0, daoluyszjyfw.length - 1);
        }


        var guanjianbgurl = "";
        var guanjianbgurlArr = that.guanjianbgurlArr;
        if (guanjianbgurlArr.length > 0) {
          for (var k = 0; k < guanjianbgurlArr.length; k++) {
            guanjianbgurl += guanjianbgurlArr[k] + ",";
          }
          if (guanjianbgurl.length > 0) {
            guanjianbgurl = guanjianbgurl.substr(0, guanjianbgurl.length - 1);
          }
        }

        var guantitiji = values.guantitiji;
        if (parseFloat(guantitiji) <= 0) {
          Toast.fail('请填写正确的罐体体积');
          return false;
        }
      }

      
      var zhengbeizhiliang = values.zhengbeizhiliang ? values.zhengbeizhiliang : 0;
      if (parseFloat(zhengbeizhiliang) <= 0 && that.vehicleUsage.typecode == '2') {
        Toast.fail('请填写正确的整备质量');
        return false;
      }

      
      var xingshizhenghdzzl = values.xingshizhenghdzzl ? values.xingshizhenghdzzl : 0;


      if(!that.guanticaizhi)
      {
        Toast.fail('请选择罐体材质');
        return false;
      }

      if(!that.cabinValue && that.vehicleUsage.typecode == '2')
      {
        Toast.fail('请选择舱室');
        return false;
      }
      
      // 验证货舱数量
      if (!that.cssl) {
        Toast.fail('请选择货舱数量');
        return false;
      }

      //判断舱室立方
      var cangshi  = "";
      switch (this.cabinValue) {
        case "单舱":
          cangshi = "01";
          break;
        case "双舱":
          cangshi = "02";
          break;
        case "三舱":
          cangshi = "03";
          break;
      }
      var cangshilifang1 = this.cangshilifang1;
      var cangshilifang2 = this.cangshilifang2;
      var cangshilifang3 = this.cangshilifang3;

      that.$data.loadingBtn = true;
      var formData = JSON.stringify({
        openid: that.$store.state.wx_info.openid,
        cheguahao: values.cheguahao,
        xingshizhengyxq: that.$data.xingshizhengyxq,
        sscd: values.sscd,
        zhengbeizhiliang: zhengbeizhiliang,
        chejiahao: values.chejiahao ? values.chejiahao : "",
        xingshizhenghdzzl: xingshizhenghdzzl,
        xingshizhengzbzmurl: that.$data.xsz_zb_zm_url,
        xingshizhengzbfmurl: that.$data.xsz_zb_fm_url,
        xingshizhengfbzmurl: that.$data.xsz_fb_zm_url,
        xingshizhengfbfmurl: that.$data.xsz_fb_fm_url,
        daoluyszhao: values.daoluyszhao,
        daoluyszjyfw: daoluyszjyfw,
        daoluyszyxq: that.$data.daoluyszyxq,
        daoluyszzbzmurl: that.$data.dlys_zm_url,
        daoluyszdlzmurl: that.$data.dcl_zm_url,
        daoluyszdlfmurl: that.$data.dcl_fm_url,
        guanjianjyfw: guanjianjyfw,
        guantitiji: guantitiji,
        guanjianyxq: that.$data.guanjianyxq,
        guanjianbgurl: guanjianbgurl,
        beizhu: values.beizhu,
        id: that.$data.id,
        cangshi:cangshi,
        cangshilifang1:cangshilifang1,
        cangshilifang2:cangshilifang2,
        cangshilifang3:cangshilifang3,
        cangshilifang4:0,
        guanticaizhi:that.guanticaizhi,
        sfjzx:that.sfjzx,
        cssl: that.cssl,
        vehicleUsage:that.vehicleUsage.typecode,
      });

      if(!that.guanticaizhi)
      {
        Toast.fail('请选择罐体材质');
        return false;
      }

      if (guanjianjyfw) {
        api.isgeneralgood(encodeURIComponent(guanjianjyfw)).then(function(res) {
          var resData = JSON.parse(res);
          if (resData.respCode == "0") {
            if (resData.data == 'N') {
              if (guanjianbgurlArr.length == 0) {
                Toast.fail('请上传罐检图片');
                return false;
              }

              if (!that.$data.guanjianyxq) {
                Toast.fail('请选择罐检有效期');
                return false;
              }

              if (gtSelectedData.length == 0) {
                Toast.fail('请选择罐检经营范围');
                return false;
              }
            }

            that.uploadFormData(formData);

          } else {
            Dialog.alert({
              message: resData.message,
            }).then(() => {
              // on confirm
            });
          }
        });
      } else {
        that.uploadFormData(formData);
      }

    },
    uploadFormData(formData) {
      var that = this;
      api.updateBeianChegua(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          // 清掉首页车辆缓存，让回首页时重新拉最新行驶证有效期
          localStorage.removeItem('vehicleInfo');
          that.autoSubmitBeian('chegua', that.$data.id, 'cheguaList');
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            // on confirm
          });
        }
      }).catch(function(err) {
        console.log(err);
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');

      });
    },
    getXszYxq(xszYxq) {
      this.$data.xingshizhengyxq = xszYxq
    },
    getDlysYxq(xszYxq) {
      this.$data.daoluyszyxq = xszYxq
    },
    getDlysChosePz(selectedData) {
      this.$data.selectedData = selectedData;
      this.pzArray = selectedData;
    },
    getGtChosePz(selectedData) {
      this.$data.gtSelectedData = selectedData;
      this.gtPzArray = selectedData;

    },
    getguanjianyxq(xszYxq) {
      this.$data.guanjianyxq = xszYxq
    },
    mergeinfo(detail) {
      var that = this;
      const weburl = that.GLOBAL.weburl;
      that.cheguahao = detail.cheguahao ? detail.cheguahao : that.cheguahao;
      that.xingshizhengyxq = detail.xingshizhengyxq ? detail.xingshizhengyxq : that.xingshizhengyxq;
      that.sscd = detail.sscd ? detail.sscd : that.sscd;
      that.zhengbeizhiliang = detail.zhengbeizhiliang ? detail.zhengbeizhiliang : that.zhengbeizhiliang;
      that.chejiahao = detail.chejiahao ? detail.chejiahao : that.chejiahao;
      that.xingshizhenghdzzl = detail.xingshizhenghdzzl ? detail.xingshizhenghdzzl : that.xingshizhenghdzzl;
      that.daoluyszhao = detail.daoluyszhao ? detail.daoluyszhao : that.daoluyszhao;
      that.beizhu = detail.beizhu ? detail.beizhu : that.beizhu;
      that.daoluyszyxq = detail.daoluyszyxq ? detail.daoluyszyxq : that.daoluyszyxq;
      that.guantitiji = detail.guantitiji ? detail.guantitiji : that.guantitiji;
      that.guanjianyxq = detail.guanjianyxq ? detail.guanjianyxq : that.guanjianyxq;
      that.guanjianjyfw = detail.guanjianjyfw ? detail.guanjianjyfw : that.guanjianjyfw;

      var daoluyszjyfw = that.daoluyszjyfw = detail.daoluyszjyfw;
      var pzArrayOld = daoluyszjyfw.split('|');

      let pzArrayNew = [];

      //var pzList = that.pzList;

      for (var i = 0; i < pzArrayOld.length; i++) {
        pzArrayNew.push(pzArrayOld[i]);
      }
      that.selectedData = that.pzArray = pzArrayNew;

      var guanjianjyfw = that.guanjianjyfw;
      var gtPzArrayOld = guanjianjyfw.split('|');

      let gtPzArrayNew = [];
      for (var j = 0; j < gtPzArrayOld.length; j++) {
        gtPzArrayNew.push(gtPzArrayOld[j]);
      }
      that.gtPzArray = that.gtSelectedData = gtPzArrayNew;

      that.xsz_zb_zm_url = detail.xingshizhengzbzmurl ? detail.xingshizhengzbzmurl : that.xsz_zb_zm_url;
      that.xsz_zb_fm_url = detail.xingshizhengzbfmurl ? detail.xingshizhengzbfmurl : that.xsz_zb_fm_url;
      that.xsz_fb_zm_url = detail.xingshizhengfbzmurl ? detail.xingshizhengfbzmurl : that.xsz_fb_zm_url;
      that.xsz_fb_fm_url = detail.xingshizhengfbfmurl ? detail.xingshizhengfbfmurl : that.xsz_fb_fm_url;
      that.dlys_zm_url = detail.daoluyszzbzmurl ? detail.daoluyszzbzmurl : that.dlys_zm_url;
      that.dcl_zm_url = detail.daoluyszdlzmurl ? detail.daoluyszdlzmurl : that.dcl_zm_url;
      that.dcl_fm_url = detail.daoluyszdlfmurl ? detail.daoluyszdlfmurl : that.dcl_fm_url;


      that.xsz_zb_zm_image = detail.xingshizhengzbzmurl ? [{
        url: weburl + '/' + detail.xingshizhengzbzmurl
      }] : that.xsz_zb_zm_image;
      that.xsz_zb_fm_image = detail.xingshizhengzbfmurl ? [{
        url: weburl + '/' + detail.xingshizhengzbfmurl
      }] : that.xsz_zb_fm_image;
      that.xsz_fb_zm_image = detail.xingshizhengfbzmurl ? [{
        url: weburl + '/' + detail.xingshizhengfbzmurl
      }] : that.xsz_fb_zm_image;
      that.xsz_fb_fm_image = detail.xingshizhengfbfmurl ? [{
        url: weburl + '/' + detail.xingshizhengfbfmurl
      }] : that.xsz_fb_fm_image;
      that.dlys_zm_image = detail.daoluyszzbzmurl ? [{
        url: weburl + '/' + detail.daoluyszzbzmurl
      }] : that.dlys_zm_image;
      that.dcl_zm_image = detail.daoluyszdlzmurl ? [{
        url: weburl + '/' + detail.daoluyszdlzmurl
      }] : [];
      that.$data.dcl_fm_image = detail.daoluyszdlfmurl ? [{
        url: weburl + '/' + detail.daoluyszdlfmurl
      }] : that.$data.dcl_fm_image;

      var guanjianbgurl = detail.guanjianbgurl;
      var guanjianbgImageArr = that.guanjianbgImageArr;
      var guanjianbgurlArr = that.guanjianbgurlArr;
      if (guanjianbgurl) {
        var imageDataArr = guanjianbgurl.split(',');
        for (var k = 0; k < imageDataArr.length; k++) {
          if (guanjianbgImageArr.length > 0) {
            guanjianbgImageArr.push({
              'url': weburl + '/' + imageDataArr[k]
            });
            guanjianbgurlArr.push(imageDataArr[k]);
          } else {
            guanjianbgImageArr = imageDataArr[k] ? [{
              url: weburl + '/' + imageDataArr[k]
            }] : [];
            guanjianbgurlArr = imageDataArr[k] ? [imageDataArr[k]] : [];
          }
        }

        that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgImageArr;
        that.guanjianbgurlArr = guanjianbgurlArr;
      }
    },
    //上传行驶证正本正面
    uploadXszZbZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_zb_zm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCheguaXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.xsz_zb_zm_url = imageData.xingshizhengzbzmurl ? imageData.xingshizhengzbzmurl : "";
          that.$data.xsz_zb_zm_image = imageData.xingshizhengzbzmurl ? [{
            url: weburl + '/' + imageData.xingshizhengzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);

      });
    },
    //上传行驶证正本反面 正页
    uploadXszZbFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_zb_fm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCheguaXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.xsz_zb_fm_url = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
          that.$data.xsz_zb_fm_image = imageData.xingshizhengzbfmurl ? [{
            url: weburl + '/' + imageData.xingshizhengzbfmurl
          }] : [];

          if (imageData.bpmStatus === "3") {
            var detail = imageData;
            that.mergeinfo(detail);
          } else {
            that.$data.xsz_zb_fm_url = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
            that.$data.cheguahao = imageData.cheguahao ? imageData.cheguahao : that.$data.cheguahao; //车头号
            that.$data.sscd = imageData.sscd ? imageData.sscd : that.$data.sscd; //所属车队
            that.$data.chejiahao = imageData.chejiahao ? imageData.chejiahao : that.$data.chejiahao; //车辆识别代号
          }

        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);

      });
    },
    //上传行驶证副本正面 副页
    uploadXszFbZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_fb_zm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadCheguaXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.xsz_fb_zm_url = imageData.xingshizhengfbzmurl ? imageData.xingshizhengfbzmurl : "";
          that.$data.xsz_fb_zm_image = imageData.xingshizhengfbzmurl ? [{
            url: weburl + '/' + imageData.xingshizhengfbzmurl
          }] : [];

          if (imageData.bpmStatus === "3") {
            var detail = imageData;
            that.mergeinfo(detail);
          } else {
            that.$data.xingshizhengyxq = imageData.xingshizhengyxq ? imageData.xingshizhengyxq : that.$data.xingshizhengyxq; //行驶证有效期
            that.$data.zhengbeizhiliang = imageData.zhengbeizhiliang ? imageData.zhengbeizhiliang : that.$data.zhengbeizhiliang; //整备质量
            that.$data.xingshizhenghdzzl = imageData.xingshizhenghdzzl ? imageData.xingshizhenghdzzl : that.$data.xingshizhenghdzzl; //行驶证核定载质量
          }
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);

      });
    },
    //上传行驶证副本反面
    uploadXszFbFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_fb_fm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCheguaXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.xsz_fb_fm_url = imageData.xingshizhengfbfmurl ? imageData.xingshizhengfbfmurl : "";
          that.$data.xsz_fb_fm_image = imageData.xingshizhengfbfmurl ? [{
            url: weburl + '/' + imageData.xingshizhengfbfmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }

      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);

      });
    },
    //道路运输证正本正面图片
    uploadDlysZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCgDlys(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.dlys_zm_url = imageData.daoluyszzbzmurl ? imageData.daoluyszzbzmurl : "";
          that.$data.dlys_zm_image = imageData.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData.daoluyszzbzmurl
          }] : [];
          if(imageData.daoluyszyxq) that.daoluyszyxq = imageData.daoluyszyxq;
          if(that.cheguahao != imageData.cheguahao && that.cheguahao)
          {
            Toast.fail("证件车辆与登记车挂号不符合");
          }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          var imageData2 = resData.data;
          that.dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } 
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);

      });

    },
    uploadDclZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      const type = 'dcl_zm';
      api.uploadCgDcl(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.dcl_zm_url = imageData.daoluyszdlzmurl ? imageData.daoluyszdlzmurl : "";
          that.$data.dcl_zm_image = imageData.daoluyszdlzmurl ? [{
            url: weburl + '/' + imageData.daoluyszdlzmurl
          }] : [];
          if(imageData.daoluyszyxq) that.daoluyszyxq = imageData.daoluyszyxq;
          if(that.cheguahao != imageData.cheguahao && that.cheguahao)
          {
            Toast.fail("证件车辆与登记车挂号不符合");
          }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          var imageData2 = resData.data;
          that.dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } 
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);

      });
    },
    uploadDclFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      const type = 'dcl_fm';
      api.uploadCgDcl(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.dcl_fm_url = imageData.daoluyszdlfmurl ? imageData.daoluyszdlfmurl : "";
          that.$data.dcl_fm_image = imageData.daoluyszdlfmurl ? [{
            url: weburl + '/' + imageData.daoluyszdlfmurl
          }] : [];
          if(imageData.daoluyszyxq) that.daoluyszyxq = imageData.daoluyszyxq;
          if(that.cheguahao != imageData.cheguahao && that.cheguahao)
          {
            Toast.fail("证件车辆与登记车挂号不符合");
          }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          var imageData2 = resData.data;
          that.dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } 
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);

      });
    },
    uploadGtImage(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;

      let formData = new FormData();
      if (Array.isArray(file)) {
        file.forEach((item) => {
          formData.append("uploadpics", item.file);
        })
      } else {
        formData.append("uploadpics", file.file);
      }

      formData.append("ctid", '');
      api.uploadGtImage(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data.guanjianbgurl;
          var guanjianbgImageArr = that.guanjianbgImageArr;
          var guanjianbgurlArr = that.guanjianbgurlArr;

          var imageDataArr = imageData.split(',');

          for (var i = 0; i < imageDataArr.length; i++) {
            if (guanjianbgImageArr.length > 0) {
              guanjianbgImageArr.push({
                'url': weburl + '/' + imageDataArr[i]
              });
              guanjianbgurlArr.push(imageDataArr[i]);
            } else {
              guanjianbgImageArr = imageDataArr[i] ? [{
                url: weburl + '/' + imageDataArr[i]
              }] : [];
              guanjianbgurlArr = imageDataArr[i] ? [imageDataArr[i]] : [];
            }
          }

          that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgImageArr;
          that.guanjianbgurlArr = guanjianbgurlArr;
          if(resData.data.guanjianyxq) that.guanjianyxq = resData.data.guanjianyxq;
          if(resData.data.guantitiji) that.guantitiji = resData.data.guantitiji;
          if(that.cheguahao != imageData.cheguahao && that.cheguahao)
          {
            Toast.fail("证件车辆与登记车挂号不符合");
          }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          var imageData2 = resData.data.guanjianbgurl;
          var guanjianbgImageArr2 = that.guanjianbgImageArr;
          var guanjianbgurlArr2 = that.guanjianbgurlArr;

          var imageDataArr2 = imageData2.split(',');

          for (var i2 = 0; i2 < imageDataArr2.length; i2++) {
            if (guanjianbgImageArr2.length > 0) {
              guanjianbgImageArr2.push({
                'url': weburl + '/' + imageDataArr2[i]
              });
              guanjianbgurlArr2.push(imageDataArr2[i]);
            } else {
              guanjianbgImageArr2 = imageDataArr2[i] ? [{
                url: weburl + '/' + imageDataArr2[i]
              }] : [];
              guanjianbgurlArr2 = imageDataArr2[i] ? [imageDataArr2[i]] : [];
            }
          }

          that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgImageArr2;
          that.guanjianbgurlArr = guanjianbgurlArr2;
        }
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deleteXszZbFm() {
      this.$data.xsz_zb_fm_url = "";
      this.$data.xsz_zb_fm_image = [];
    },
    deleteXszFbZm() {
      this.$data.xsz_fb_zm_url = "";
      this.$data.xsz_fb_zm_image = [];
    },
    deleteXszFbFm() {
      this.$data.xsz_fb_fm_url = "";
      this.$data.xsz_fb_fm_image = [];
    },
    deleteXszZbZm() {
      this.$data.xsz_zb_zm_url = "";
      this.$data.xsz_zb_zm_image = [];
    },
    deleteDlysZm() {
      this.$data.dlys_zm_url = "";
      this.$data.dlys_zm_image = [];
    },
    deleteDclZm() {
      this.$data.dcl_zm_url = "";
      this.$data.dcl_zm_image = [];
    },
    deleteDclFm() {
      this.$data.dcl_fm_url = "";
      this.$data.dcl_fm_image = [];
    },
    deleteGtImage(file) {
      var that = this;
      const weburl = that.GLOBAL.weburl;
      var guanjianbgImageArr = that.guanjianbgImageArr;
      var guanjianbgNewImageArr = [];
      var guanjianbgNewUrlArr = [];
      for (var i = 0; i < guanjianbgImageArr.length; i++) {
        if (guanjianbgImageArr[i].url != file.url) {
          guanjianbgNewImageArr.push(guanjianbgImageArr[i]);
          var path = guanjianbgImageArr[i].url.replace(weburl, '');
          guanjianbgNewUrlArr.push(path);
        }
      }
      that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgNewImageArr;
      that.guanjianbgurlArr = guanjianbgNewUrlArr;
    },
    showImageDemo(type) {
      let images = [];
      switch (type) {
        case 'zbzm':
          images = [require('@/assets/images/cgsl.png')];
          break;
        case 'zbfm':
          images = [require('@/assets/images/zbfm.png')];
          break;
        case 'fbzm':
          images = [require('@/assets/images/fbzm.png')];
          break;
        case 'fbfm':
          images = [require('@/assets/images/fbfm.png')];
          break;
        case 'dlyszm':
          images = [require('@/assets/images/cgdlyszm.png')];
          break;
        case 'dlczm':
          images = [require('@/assets/images/cgdlczm.jpg')];
          break;
        case 'dlcfm':
          images = [require('@/assets/images/dlcfm.jpg')];
          break;
      }

      ImagePreview({
        images: images,
        closeable: true,
      });
    },
    setCabin(value)
    {
      this.cabinValue = value;
    },
    getCsValue1(value)
    {
      this.cangshilifang1 = value;
    },
    getCsValue2(value)
    {
      this.cangshilifang2 = value;
    },
    getCsValue3(value)
    {
      this.cangshilifang3 = value;
    },
    changeGtMaterial(data)
    {
      this.guanticaizhi = data;
    },
  }
};
</script>

<style lang="scss" scoped>
.content {
    margin-top: 1rem;
    margin-bottom: 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
}

.itemBox {
    margin-top: 1rem;
}

.upload-box {
    //border-top: 1px solid #ececec;
    background: #fff;
    margin-top: 0.625rem;
    .upload-titile {
        padding: 0.675rem 1rem;
        .image-show {
            margin-left: 0.5rem;
            color: #2440b3;
        }
    }
    .title-extend {
        line-height: 1.5;
    }
    .upload-xsz-box {
        margin-left: 1rem;
    }
    .upload-dlysz-box {
        margin-left: 1rem;
    }

}

.pz-box {
    .van-checkbox-group {
        margin-left: 1rem;
    }
}

.unit {
    padding-left: 0.2rem;
    color: #969799;
}

.red-required::before{
  position: absolute;
  left: 8px;
  color: #ee0a24;
  font-size: 14px;
  content: '*';
}
</style>
